<div class="card-product -title">
  @if (icon) {
  <icon [icon]="icon"></icon>
  } @if (lucideIcon) {
  <lucide-icon [name]="lucideIcon"></lucide-icon>
  }
  <h3>{{ title }}</h3>
</div>
<ng-content></ng-content>
